import { Suggestion } from '../../../ui/gzTextareaWithSuggestions/types';
import { GzChatCardState } from '../../gzChatCard/types';

export interface AiChatData {
  status: AiChatStatus;
  chatItems: AiChatItemData[];
  defaultQuestionList: Suggestion[];
  totalNumberOfQuestions: number;
  currentNumberOfQuestions: number;
}

export interface AiChatItemData {
  _id?: string;
  type: AiChatItemType;
  message?: string;
  created?: number;
  isQuestion?: boolean;
  state: GzChatCardState;
  incident: AiChatIncident;
  companyId?: string;
  user?: AiChatUser;
  feedback?: AiChatFeedback;
  errorState?: boolean;
}

export interface AiChatQuestion {
  _id: string,
  text: string
}

interface AiChatFeedback {
  message: string;
  rating: number;
}

interface AiChatIncident {
  incidentId: string;
  insightId?: string;
}

interface AiChatUser {
  userName: string;
  userId?: string;
  companyId?: string;
}

export interface AiChatIncidentHistoryUpdate {
  _id: string;
  type: number;
  incidentId: string;
  created: number;
  lastProcessed: number;
  specifics: {
    newAlertsCount: number;
    newNodesCount: number;
  }
}

export interface AiChatQuestionsDetail {
  totalNumberOfQuestions: number;
  availableNumberOfQuestions: number;
}

export enum IncidentHistoryUpdateTypes {
  INCIDENT_CREATED = 1,
  INCIDENT_UPDATED = 2,
  STATUS_CHANGED = 3,
  ASSIGN_INCIDENT = 4,
  UNASSIGN_INCIDENT = 5,
  PRIORITY_CHANGED = 6,
  NOTE_ADDED = 7,
  NOTE_UPDATED = 8,
  NOTE_DELETED = 9,
}

export enum AiChatItemType {
  CHAT_CARD = 1,
  INCIDENT_UPDATE = 2,
}

export enum AiChatStatus {
  ACTIVE = 'active',
  EMPTY = 'empty',
  UNAVAILABLE = 'unavailable',
  MAX_XRCA_SIZE_EXCEEDED_AFTER_UPDATE = 'maxXRCASizeExceededAfterUpdate',
  XRCA_NOT_FOUND_IN_ES_AFTER_UPDATE = 'xrcaNotFoundInESAfterUpdate',
}

export enum DracoAIErrors {
  NO_ERROR = 0,
  XRCA_NOT_FOUND_IN_ES = 1,
  MAX_XRCA_SIZE_EXCEEDED = 2,
}

export enum AiChatEvents {
  LOAD_RESPONSE_FAILED = 'load-response-failed',
}
